module.exports = __webpack_public_path__ + "img/auth.3554a0a7.png";